
import MUIDataTable from 'mui-datatables'
import { Link, withRouter } from 'react-router-dom';
import "../../../css/Users.css"
import { logOut } from '../../helper';
import React, { Component } from 'react';
import { Form, Col } from 'react-bootstrap';
import axiosInstance from '../../../axiosInstance';


const columns = [
    {
        "name": "user",
        "label": "მომხმარებელი",
        "options": {
            "sort": true
        }
    },
    {
        "name": "role",
        "label": "როლი",
        "options": {
            "sort": true
        }
    },
    {
        "name": "action",
        "label": "მოქმედება",
        "options": {
            "sort": true
        }
    },
    {
        "name": "updated_column",
        "label": "განახლებული ველი",
        "options": {
            "sort": true
        }
    },
    {
        "name": "old_value",
        "label": "ძველი",
        "options": {
            "sort": true
        }
    },
    {
        "name": "new_value",
        "label": "ახალი",
        "options": {
            "sort": true
        }
    },
    {
        "name": "created_at",
        "label": "თარიღი",
        "options": {
            "sort": true
        }
    },

]
class TicketLogs extends Component {
    constructor(props) {

        super(props);
        this.state = {
            data: [],
            selected_role: -1,
            options: {
                filterType: 'checkbox',
                selectableRowsHeader: false,
                expandableRowsHeader: false,
                viewColumns: false,
                print: false,
                filter: false,
                selectableRows: 'none',
            },
            response: {
                isValid: false,
                isInValid: false,
                message: 'პრობლემა წარმატებით ჩაემატა'
            }
        }

    }
    componentDidMount() {
        this.fetch_logs();
    }




    fetch_logs() {
        axiosInstance.get('tickets/' + this.props.match.params.id + '/logs')
            .then(response => {
                let logs_array = [];
                response.data.data.forEach(element => {
                    logs_array.push({
                        user: element.user.username,
                        role: element.user.role,
                        action: element.action,
                        old_value: element.old_value,
                        new_value: element.new_value,
                        updated_column: element.updated_column,
                        created_at:element.created_at
                    })
                });
                this.setState({
                    data: logs_array
                })
            })
            .catch(err => {
                if (err.response !== null) {
                    if (err.response.status === 401) {
                        logOut(this.props);
                    }
                }
            })
    }

    on_fetch_logs(data) {
        this.setState({
            data: data
        })
    }

    on_bad_request(data) {
        this.setState({
            response: {
                ...this.state.response,
                isInValid: true,
                message: data.messages
            }
        })
    }


    render() {

        return (
            <div className="content-main">
                <Form.Row>
                    <Form.Group as={Col} md="4" >
                        <Form.Control
                            problem="text"
                            name="problem"
                            hidden={true}
                            isInvalid={Boolean(this.state.response.isInValid)}
                            isValid={Boolean(this.state.response.isValid)}
                            onChange={null}
                        />
                        <Form.Control.Feedback type="invalid" >
                            {this.state.response.message}
                        </Form.Control.Feedback>

                        <Form.Control.Feedback >
                            {this.state.response.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <MUIDataTable
                    data={this.state.data}
                    columns={columns}
                    options={this.state.options}
                />
                <Link to="/dashboard" id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>

            </div>
        )
    }
}
export default withRouter(TicketLogs);